/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import SearchInput from "src/components/widgets/SearchInput";
import BackIcon from "../images/back.png";
import { useQuery } from "@tanstack/react-query";
import { getInventoryLogs } from "src/api/inventory";
import CustomDataTable from "src/components/CustomDataTable";
import { format } from "date-fns";
import CustomSelect from "src/components/CustomSelect";
import { useDashboardContext } from "src/context/DashboardContext";
import { getCustomizationValue, renderNumber } from "src/lib/utils";
import { useAuth } from "src/providers/AuthProvider";

const columns = [
	{ name: "S/N", selector: (_, index) => index + 1, grow: 0.4 },
	{ name: "Product Name", selector: (row) => row.name, grow: 1.5 },
	{ name: "Qty", selector: (row) => renderNumber(row.qty) },
	{ name: "Direction", selector: (row) => row.type },
	{ name: "By", selector: (row) => row?.first_name?.concat(" ", row?.last_name) ?? "N/A" },
	{ name: "Date", selector: (row) => format(row.created_at, "PPP") },
];

const InventoryLogs = () => {
	const { user } = useAuth();
	const navigate = useNavigate();
	const { entities } = useDashboardContext();
	const [searchParams, setSearchParams] = useSearchParams();

	const search = searchParams.get("search");
	const page = searchParams.get("page") || 1;
	const entity = searchParams.get("entity") ?? "";
	const limit = searchParams.get("limit") || 10;

	const updateSearchParams = (key, value) => {
		const newSearchParams = new URLSearchParams(searchParams);

		if (value === "0") {
			newSearchParams.delete(key);
		} else {
			newSearchParams.set(key, value);
		}

		setSearchParams(newSearchParams);
	};

	const { data, isLoading } = useQuery({
		queryKey: ["inventory-logs", page, limit, search, entity],
		queryFn: () => getInventoryLogs({ page, limit, search, entity }),
	});

	const logs = data?.data?.data ?? [];
	const totalRow = data?.data?.total;

	return (
		<div className="pageWrapper">
			<div className="flex-cont flex-space-between flex-align-center tw-mb-6">
				<div className="pageTop">
					<button className="transparent-btn" onClick={() => navigate("..", { relative: "path" })}>
						<img src={BackIcon} alt="back-button" />
					</button>
					<h2>{getCustomizationValue(user, "inventory_label", true)} Logs</h2>
				</div>
				<CustomSelect
					placeholder="Select Store/Warehouse"
					containerClassName="!tw-w-[230px]"
					value={entity}
					onChange={(value) => updateSearchParams("entity", value)}
					options={[{ value: "0", label: "All" }, ...entities?.map(({ name, uuid }) => ({ value: uuid, label: name }))]}
				/>
			</div>

			<div className="innerContent">
				<div className="inner-top !tw-justify-end">
					<SearchInput
						name="search_text"
						type="text"
						placeholder="Product Name"
						value={search}
						onChange={(event) => updateSearchParams("search", event.target.value)}
					/>
				</div>

				<CustomDataTable columns={columns} data={logs} progressPending={isLoading} paginationTotalRows={totalRow} />
			</div>
		</div>
	);
};

export default InventoryLogs;
